import React, { useMemo, useContext, useState } from 'react';
import { Box } from '@mui/joy';
import { KPI } from 'src/mtska-frontend-app-component';
import List from './List';
import { AppContext, useSettingsContext } from 'src/mtska-frontend-app-scaffolding';
import { useTranslation } from 'react-i18next';

const dataProviderName = 'zoho/manageableorder';

const Default = () => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);

    const [filters, setFilters] = useState()


    const { userCapabilities } = useContext(AppContext);

    const now = new Date();
    const startPreviousYear = (now.getFullYear() - 1) + '-01-01';
    const startYear = now.getFullYear() + '-01-01';
    const startPreviousMonth = now.getFullYear() + '-' + String(now.getMonth()).padStart(2, '0') + '-01';
    const startMonth = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-01';

    return useMemo(() => <>
        <Box className="mtska-chart-wrapper">

            <KPI
                title="Total Orders"
                icon="faEnvelopeCircleCheck"
                className="superuserData"
                dataProviderName={'zoho/manageableorder/statistic/total'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{

                    }]
                }}
            />

            <KPI
                title={t("Incompleti")}
                icon="faExclamationTriangle"
                dataProviderName={'zoho/manageableorder/statistic/checked'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                         field: "processStatus",
                        operator: "equals",
                        value: "to_be_worked"

                    }]
                }}
            />
            {/* <KPI
                title={t("Importable")}
                icon="faArrowUp"
                dataProviderName={'zoho/manageableorder/statistic/importable'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "actions",
                        operator: "equals",
                        value: "create"
                    }]
                }}
            /> */}
            <KPI
                title={t("Creabili")}
                icon="faExclamationTriangle"
                dataProviderName={'zoho/manageableorder/statistic/action/create'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "synchronizer.actions.actions",
                        operator: "equals",
                        value: "create"
                    }]
                }}
            />
            <KPI
                title={t("Riadeguamenti")}
                icon="faExclamationTriangle"
                dataProviderName={'zoho/manageableorder/statistic/action/reajustment'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "synchronizer.actions.actions",
                        operator: "equals",
                        value: "reajustment"
                    }]
                }}
            />
            <KPI
                title={t("Aggiornamenti")}
                icon="faArrowUp"
                dataProviderName={'zoho/manageableorder/statistic/action/update'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: (filters) => { addFilter(filters?.items[0]?.field, filters?.items[0]?.value, filters?.items[0]?.operator) }
                }}
                filters={{
                    items: [{
                        field: "synchronizer.actions.actions",
                        operator: "equals",
                        value: "update"
                    }]
                }}
            />
            
            {/* <KPI
                title={t("Synched")}
                icon="faCheck"
                dataProviderName={'zoho/manageableorder/statistic/synced'}

            /> */}


        </Box>
        <List />

    </>, [])

}

export default Default;


